const CURRENT_BUILD_TIME: string =
  typeof __BUILD_TIME__ !== 'undefined' ? __BUILD_TIME__ : '0'

export async function fetchDeployedBuildTime(): Promise<string> {
  try {
    const res = await fetch(`/version.json?_=${Date.now()}`, { cache: 'no-store' })
    if (!res.ok) return CURRENT_BUILD_TIME
    const data = (await res.json()) as { buildTime?: string }
    return data.buildTime ?? CURRENT_BUILD_TIME
  } catch {
    return CURRENT_BUILD_TIME
  }
}

export function isNewVersionAvailable(deployed: string): boolean {
  return CURRENT_BUILD_TIME !== '0' && deployed !== CURRENT_BUILD_TIME
}
